import { useCallback, useEffect, useState } from 'react';
import { useAPI } from '../../../clients/quipli-service/quipli-service-client';
import { Field } from '../../../components/field/field';
import { Typography } from '../../../components/typography/typography';
import { toast } from '../../../util/toasts';
import { Spinner } from '../../../components/spinner/spinner';
import { debounce } from 'lodash';
import usePrevious from '../../../hooks/use-previous';

export const FeeDisclaimerConfig = () => {
  const { getConfiguration, updateConfiguration } = useAPI();

  const [feeDisclaimer, setFeeDisclaimer] = useState<string>();
  const previousDisclaimer = usePrevious(feeDisclaimer);

  const toFormatPattern = (pattern: string): string => {
    return pattern.replace('{fixed}', '$0.30').replace('{percentage}', '2.9%');
  };

  const doUpdate = useCallback(
    debounce((pattern: string) => {
      updateConfiguration('CONF_FEE_DISCLAIMER_OVERRIDE', pattern).catch((err) => {
        console.error(err);
        toast('Failed to update fee disclaimer', 'error');
      });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (feeDisclaimer === undefined) return;

    const f = toFormatPattern(feeDisclaimer);
    setFeeDisclaimer(f);
    previousDisclaimer && previousDisclaimer !== feeDisclaimer && doUpdate(f);
  }, [feeDisclaimer]);

  useEffect(() => {
    getConfiguration('CONF_FEE_DISCLAIMER_OVERRIDE')
      .then((res) => setFeeDisclaimer(res?.value || ''))
      .catch(() => toast('Failed to load order number format', 'error'));
  }, []);

  return feeDisclaimer !== undefined ? (
    <div className="flex flex-col gap-1">
      <Field type="text" value={feeDisclaimer} onChange={setFeeDisclaimer} />
      <Typography type="text-xs" className={'!italic !text-grey-700'}>
        Format of the fee disclaimer.
        <br />
        Result: <b>{toFormatPattern(feeDisclaimer)}</b>
      </Typography>

      <Typography type="text-xs" className="!text-grey-700 !italic">
        Available tokens:
        <br />- <b>{`{fixed}:`}</b> Fixed fee amount
        <br />- <b>{`{percentage}:`}</b> Percentage fee amount
      </Typography>
    </div>
  ) : (
    <Spinner />
  );
};
